/* @flow */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Card, Row, Col } from 'reactstrap';
import _ from 'lodash';
import cx from 'classnames';
import * as d3 from 'd3';

import ReportInputParams from '../ReportInputParams';
import ReportOutputParams from '../ReportOutputParams';
import ChartLineGraph from '../ChartLineGraph';

import { getFieldValues } from '../../selectors/design';

import classes from './AnalysisWrapper.scss';

// const log = require('bows')('AnalysisWrapper');

type PropsType = {
  figures: {
    [key: string]: Array<any>,
  },
  tables: {
    InputTable: Array<any>,
    OutputTable1: Array<any>,
    OutputTable2: Array<any>,
  },
};

export class AnalysisWrapper extends React.Component<PropsType, *> {
  static defaultProps = {
    figures: {},
    tables: {},
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  componentDidMount() {
    // Adjust the graphs and legends after the components have been generated.
    // There might be an easier way to do this?
    const groups = d3.selectAll('.graph');
    groups.each(function each() {
      let viewBox: string = this.getAttribute('viewBox');
      const legend = d3.select(this).select('.legend').select('g');

      const legendGroup = legend.node();

      const width = Math.round(legendGroup.getBoundingClientRect().width);
      legendGroup.previousElementSibling.setAttribute('width', width);

      const wrapper = legendGroup.parentNode;
      wrapper.setAttribute('transform', `translate(-${40 + 10 + 10 + width}, 5)`);

      // set the SVG viewbox
      viewBox = viewBox.replace('0', `-${width / 2}`);
      this.setAttribute('viewBox', viewBox);
    });
  }

  render() {
    const renderGraphs = () => _.map(
      this.props.figures,
      (d: any, k: string) => {
        let title;
        const num = Number(k.replace('Figure', ''));

        if (num < 7) {
          title = <h5 style={{ textAlign: 'center' }}>{`${num % 2 ? 'High' : 'Low'}-Side`}</h5>;
        }
        return (
          <Col sm={12} md={12} lg={6} key={k}>
            {title}
            <ChartLineGraph graphNum={num.toString()} {...d} />
          </Col>
        );
      },
    );

    return (<Row>
      <h4 className={cx('col col-sm-12', classes.cardHeader)}>
          Analysis
      </h4>
      <Col>
        <Card body>
          <Row>
            <Col md={12} lg={4}>
              <h4>Input</h4>
              <ReportInputParams tableData={this.props.tables.InputTable} />
            </Col>
            <Col md={12} lg={4}>
              <h4>Output</h4>
              <ReportOutputParams tableData={this.props.tables.OutputTable1} />
            </Col>
            <Col md={12} lg={4}>
              <h4>&nbsp;</h4>
              <ReportOutputParams tableData={this.props.tables.OutputTable2} />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h4>Graphs</h4>
            </Col>
            {renderGraphs()}
          </Row>
        </Card>
      </Col>
    </Row>);
  }
}

function mapStateToProps(state: AppStateType) {
  const values = getFieldValues(state);

  const tables = ['InputTable', 'OutputTable1', 'OutputTable2'];
  const figures = Array(12).fill(0).map((v, i) => `Figure${i + 1}`);

  let data = _.pick(values, [...tables, ...figures]);
  data = _.mapValues(data, i => i.currentValue);

  return {
    tables: _.pick(data, tables),
    figures: _.omit(data, tables),
  };
}

const enhancer = compose(
  connect(mapStateToProps),
);

export default enhancer(AnalysisWrapper);



// WEBPACK FOOTER //
// ./src/components/AnalysisWrapper/AnalysisWrapper.js